export default function deleteBackupReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'DELETE_BACKUP_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_BACKUP_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_BACKUP_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}